<template>
  <v-app>
    <v-app-bar
      app
      dark
      :color="appBarColor"
    >
      <router-link :to="{ name: getHomeRoute }">
        <!--
        <v-img src="@/assets/drawer-avatar.png"
          v-if="$vuetify.breakpoint.xs"
          alt="Chaffis"
          class="mx-2"
          max-height="60"
          max-width="60"
          contain
        >
        </v-img>
        <v-img src="@/assets/header-logo.png"
          v-if="$vuetify.breakpoint.smAndUp"
          alt="Chaffis"
          class="mx-2"
          max-height="60"
          max-width="120"
          contain
        >
        </v-img>
        -->
        <!--had no success with dynamic src attr when it involved '@/assets', so we output two different ones with v-if-->
        <v-img
          v-if="isLoggedInAs"
          src="@/assets/header-logo-white.png"
          alt="Chaffis"
          class="mx-2"
          max-height="60"
          max-width="120"
          contain
        >
        </v-img>
        <v-img
          v-if="!isLoggedInAs"
          src="@/assets/header-logo.png"
          alt="Chaffis"
          class="mx-2"
          max-height="60"
          max-width="120"
          contain
        >
        </v-img>
      </router-link>
      <v-spacer></v-spacer>
      <!--
      <v-btn
        link
        icon
        :to="{ name: 'home' }"
      >
        <v-icon>
          mdi-home
        </v-icon>
      </v-btn>
      -->
      <template>
        <div
          v-if="isLoggedInAs"
        >
          <v-tooltip
            left
          >
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                @click="logoutAs()"
              >
                <v-icon
                  size="32"
                >
                  mdi-logout
                </v-icon>
              </v-btn>
            </template>
            <span>Återgå till admin</span>
          </v-tooltip>
        </div>
        <div
          v-if="isAdmin"
        >
          <v-tooltip
            left
          >
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                @click="goToAdmin()"
              >
                <v-icon
                  size="32"
                >
                  mdi-shield-account-outline
                </v-icon>
              </v-btn>
            </template>
            <span>Administrera</span>
          </v-tooltip>
        </div>
        <div>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                @click="reportBug()"
              >
                <v-icon
                  size="32"
                >
                  mdi-chat-alert-outline
                </v-icon>
              </v-btn>
            </template>
            <span>Rapportera en bugg etc</span>
          </v-tooltip>
        </div>
        <div>
          <v-menu
            v-if="isLoggedIn"
            v-model="profileMenu"
            :close-on-content-click="true"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
              >
                <v-icon
                  size="32"
                >
                  mdi-account-circle-outline
                </v-icon>
              </v-btn>
            </template>
            <v-card
              min-width="300"
              class="profileMenu"
            >
              <v-card-actions>
                <v-img src="@/assets/drawer-avatar.png"
                  alt="Chaffis"
                  class="mx-2"
                  max-height="40"
                  max-width="40"
                  contain
                >
                </v-img>
                <div class="text-button" :class="isDeveloper ? 'developer-text' : ''" v-text="agentTypeName"></div>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="logout()"
                >
                  Logga ut
                </v-btn>
              </v-card-actions>
              <v-divider></v-divider>
              <v-list>
                <v-list-item>
                  <v-list-item-avatar size="62">
                    <v-icon size="50">mdi-account-circle-outline</v-icon>
                    <!--
                    <v-img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John"></v-img>
                    -->
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ agentName }}</v-list-item-title>
                    <v-list-item-subtitle v-if="agentType == 'company'">{{ userName }}</v-list-item-subtitle>
                    <v-list-item-title>
                      <v-btn
                        class="mt-2"
                        small
                        depressed
                        color="secondary"
                        :to="{ name: 'my-profile' }"
                      >
                        Min profil
                      </v-btn>
                    </v-list-item-title>
                  </v-list-item-content>
                  <!--
                  <v-list-item-action>
                    <v-btn
                      :class="fav ? 'red--text' : ''"
                      icon
                      @click="fav = !fav"
                    >
                      <v-icon>mdi-heart</v-icon>
                    </v-btn>
                  </v-list-item-action>
                  -->
                </v-list-item>
              </v-list>
              <v-divider></v-divider>
              <v-card-actions
                class="profileCard"
              >
                <span class="text-caption">
                  Version: {{ version }}
                </span>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="hasMultipleAgentAccess"
                  text
                  :to="{ name: 'switch-account' }"
                  small
                >
                  <v-icon left>mdi-shuffle-variant</v-icon>
                  Växla konto
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </div>
      </template>
    </v-app-bar>
    <!--PWA installation banner
    <v-banner
      app
      v-model="showInstallPwa"
      color="info"
      dark
      icon="mdi-export-variant"
      class="text-left"
    >
      Installera Chaffis på din telefon
      
      <template v-slot:actions>
        <v-btn text @click="dismissPwa">Avbryt</v-btn>
        <v-btn text @click="installPwa">Installera</v-btn>
      </template>
    </v-banner>-->
    <v-main>
      <transition
        name="fade"
        mode="out-in"
      >
        <router-view></router-view>
      </transition>
      <!--
      <div class="text-caption" v-html="traceOutput"></div>
      -->
    </v-main>
    <!--external bug report form
    <form name="form_bugReport" action="https://chaffis.se/beta" target="_blank" method="post" style="display:none">-->
    <form name="form_bugReport" action="https://www.chaffis.se/kontakt" target="_blank" method="post" style="display:none">
      <input type="hidden" name="field_1_1" />
      <input type="hidden" name="field_1_7" />
    </form>
    <!--internal bug report form
    <v-dialog
      v-model="dialogReportBug"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Rapportera bugg/synpunkt</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="formBugReport">
              <v-row>
                <v-col class="pa-0">
                  <v-text-field
                    type="email"
                    label="E-postadress*"
                    outlined
                    v-model="bugReportEmail"
                    :rules="[formRules.required, formRules.email]"
                    validate-on-blur
                    required
                    maxlength="50"
                  ></v-text-field>
                  <v-textarea
                    label="Felmeddelande/synpunkt*"
                    outlined
                    v-model="bugReportMessage"
                    :rules="[formRules.required]"
                    validate-on-blur
                    required
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogReportBug = false">Avbryt</v-btn>
          <v-btn color="accent" text @click="submitBugReport()">Skicka</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>-->
    <!--beta message
    <v-bottom-sheet
      v-model="showWelcomeAlert"
      persistent
      v-if="isBeta"
    >
      <v-sheet
        class="text-center"
        height="200px"
      >
        <v-btn
          class="mt-6"
          color="accent"
          @click="closeWelcomeAlert()"
        >Kör igång</v-btn>
        <div class="py-3">
          <div class="text-h6">Välkommen till Chaffis Beta-release!</div>
          Vi vill gärna att ni återrapporterar buggar och synpunkter via ikonen
          <v-icon>mdi-chat-alert-outline</v-icon>
          i huvudet
        </div>
      </v-sheet>
    </v-bottom-sheet>-->
    <!--footer-->
    <v-footer
      app
      dark
      v-if="!isLoggedIn"
    >
      <v-spacer></v-spacer>
      <div class="text-caption">&copy; {{ new Date().getFullYear() }} Björkli Invest AB</div>
    </v-footer>
  </v-app>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { snackBarBus } from './main'
import { generalMixin } from './mixins/general'
import { urlMixin } from './mixins/url'
import { authMixin } from './mixins/auth'

export default {
  name: 'App',
  data: () => ({
    profileMenu: false,
    isBeta: false,
    dialogReportBug: false,
    bugReportMessage: '',
//    deferredPrompt: null
  }),
  mixins: [generalMixin, urlMixin, authMixin],
  computed: {
    ...mapGetters(['isLoggedIn', 'isAdmin', 'agentType', 'agentName', 'userName', 'loggedInData', 'hasMultipleAgentAccess', 'traceOutput', 'showWelcomeAlert', 'version', 'isLoggedInAs', 'isDeveloper', 'getHomeRoute', 'access_token']),
    bugReportEmail() {
      return this.isLoggedIn ? this.loggedInData.userData.email : ''
    },
    agentTypeName() {
      if (this.agentType == 'driver') {
        return 'Chaufför'
      }
      return 'Åkeri'
    },
    appBarColor() {
      return this.isLoggedInAs ? 'info' : ''
    },
    /*
    showInstallPwa() {
      return !!this.deferredPrompt
    }
    */
  },
  methods: {
    goHome() {
      switch (this.agentType) {
        case 'company':
          this.$router.replace({ name: 'company-dashboard' })
          break
        case 'driver':
          this.$router.replace({ name: 'driver-dashboard' })
          break
        default:
          this.$router.replace({ name: 'home' })
      }
    },
    logout() {
      this.$store.dispatch('logout')
      this.$router.replace({ name: 'home' })
    },
    logoutAs() {
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let url = this.url_composeApiUrl('/admin/logout-as')
//      console.log('get', url)
      axios.get(url, config)
        .then(response => {
//          console.log('response', response)
          if (response.data.success) {
            this.auth_onAuth(response.data.returnData.access_token, response.data.returnData.loggedInData, 'logoutAs')
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          snackBarBus.$emit('message', error.toString())
        })
    },
    closeWelcomeAlert() {
      this.$store.dispatch('closeWelcomeAlert')
    },
    goToAdmin() {
      this.$router.push({ name: 'admin' })
    },
    reportBug() {
//      this.dialogReportBug = true
      let form = document.form_bugReport
      form.field_1_1.value = this.loggedInData.userData.email
//      form.field_1_7.value = navigator.userAgent
      form.submit()
    },
    submitBugReport() {
      const formIsValid = this.$refs.formBugReport.validate()
      if (!formIsValid) {
        snackBarBus.$emit('message', 'Formuläret ej komplett ifyllt')
        return
      }
      //compose postData
      let postData = {
        bugReportEmail: this.bugReportEmail,
        bugReportMessage: this.bugReportMessage,
        userAgent: navigator.userAgent
      }
      let url = this.url_composeApiUrl('/public/reportBug')
//      console.log('post', postData)
      axios.post(url, postData)
        .then(response => {
//          console.log('post response', response)
          if (response.data.success) {
            //success
          } else {
            //non success
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          snackBarBus.$emit('message', error.toString())
        })
    },
    /*
    async dismissPwa() {
      this.deferredPrompt = null;
    },
    async installPwa() {
      this.deferredPrompt.prompt();
    }
    */
  },
  created() {
    if (this.isLoggedIn) {
      this.bugReportData.email = this.loggedInData.userData.email
    }
    /*
    window.addEventListener("beforeinstallprompt", e => {
      e.preventDefault();
      // Stash the event so it can be triggered later.
      this.deferredPrompt = e;
    });
    window.addEventListener("appinstalled", () => {
      this.deferredPrompt = null;
    });
    console.log("showInstallPwa", this.showInstallPwa)
    */
  },
}
</script>
<style>
  div.v-application--wrap {
    min-height:calc(100vh - 64px) !important;
  }
  div.v-card__actions.profileCard {
    background-color: rgba(0,0,0,0.1);
  }
  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }
</style>